import styled from "styled-components";

/**
 * Wrapper do NavMenu
 * Configura o layout principal do menu de navegação.
 */
export const NavMenuWrapper = styled.ul`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  list-style: none;
  margin: 0;
  padding: 0;
  flex-direction: row; /* Alinha itens horizontalmente para desktop */
`;

/**
 * Estilo para os itens do menu
 * Define as propriedades visuais e os estilos de hover.
 */
export const NavItem = styled.li`
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.white};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  transition: color 0.2s ease-in-out;

  &:hover {
    color: ${({ theme }) => theme.colors.vividBlue};
  }
`;
